export type Currency = {
	symbol: string;
	name: string;
	symbol_native: string;
	decimal_digits: number;
	rounding: number;
	iso_code: string;
	name_plural: string;
};

export const currencies: Currency[] = [
	{
		symbol: '$',
		name: 'US Dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'USD',
		name_plural: 'US dollars',
	},
	{
		symbol: 'CA$',
		name: 'Canadian Dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'CAD',
		name_plural: 'Canadian dollars',
	},
	{
		symbol: '\u20ac',
		name: 'Euro',
		symbol_native: '\u20ac',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'EUR',
		name_plural: 'euros',
	},
	{
		symbol: 'AED',
		name: 'United Arab Emirates Dirham',
		symbol_native: '\u062f.\u0625.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'AED',
		name_plural: 'UAE dirhams',
	},
	{
		symbol: 'Af',
		name: 'Afghan Afghani',
		symbol_native: '\u060b',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'AFN',
		name_plural: 'Afghan Afghanis',
	},
	{
		symbol: 'ALL',
		name: 'Albanian Lek',
		symbol_native: 'Lek',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'ALL',
		name_plural: 'Albanian lek\u00eb',
	},
	{
		symbol: 'AMD',
		name: 'Armenian Dram',
		symbol_native: '\u0564\u0580.',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'AMD',
		name_plural: 'Armenian drams',
	},
	{
		symbol: '\u0192',
		name: 'Netherlands Antillean guilder',
		symbol_native: '\u0192',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'ANG',
		name_plural: 'Netherlands Antillean guilder',
	},
	{
		symbol: 'Kz',
		name: 'Angolan Kwanza',
		symbol_native: 'Kz',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'AOA',
		name_plural: 'Angolan Kwanzas',
	},
	{
		symbol: 'AR$',
		name: 'Argentine Peso',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'ARS',
		name_plural: 'Argentine pesos',
	},
	{
		symbol: 'AU$',
		name: 'Australian Dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'AUD',
		name_plural: 'Australian dollars',
	},
	{
		symbol: 'man.',
		name: 'Azerbaijani Manat',
		symbol_native: '\u043c\u0430\u043d.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'AZN',
		name_plural: 'Azerbaijani manats',
	},
	{
		symbol: 'KM',
		name: 'Bosnia-Herzegovina Convertible Mark',
		symbol_native: 'KM',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'BAM',
		name_plural: 'Bosnia-Herzegovina convertible marks',
	},
	{
		symbol: 'Tk',
		name: 'Bangladeshi Taka',
		symbol_native: '\u09f3',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'BDT',
		name_plural: 'Bangladeshi takas',
	},
	{
		symbol: 'BGN',
		name: 'Bulgarian Lev',
		symbol_native: '\u043b\u0432.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'BGN',
		name_plural: 'Bulgarian leva',
	},
	{
		symbol: 'BD',
		name: 'Bahraini Dinar',
		symbol_native: '\u062f.\u0628.',
		decimal_digits: 3,
		rounding: 0,
		iso_code: 'BHD',
		name_plural: 'Bahraini dinars',
	},
	{
		symbol: 'FBu',
		name: 'Burundian Franc',
		symbol_native: 'FBu',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'BIF',
		name_plural: 'Burundian francs',
	},
	{
		symbol: 'BN$',
		name: 'Brunei Dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'BND',
		name_plural: 'Brunei dollars',
	},
	{
		symbol: '$',
		name: 'Bermudian Dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'BMD',
		name_plural: 'Bermudian Dollar',
	},
	{
		symbol: 'Bs',
		name: 'Bolivian Boliviano',
		symbol_native: 'Bs',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'BOB',
		name_plural: 'Bolivian bolivianos',
	},
	{
		symbol: 'R$',
		name: 'Brazilian Real',
		symbol_native: 'R$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'BRL',
		name_plural: 'Brazilian reals',
	},
	{
		symbol: 'Nu.',
		name: 'Bhutanese Ngultrum',
		symbol_native: 'Nu.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'BTN',
		name_plural: 'Bhutanese Ngultrum',
	},
	{
		symbol: 'BWP',
		name: 'Botswanan Pula',
		symbol_native: 'P',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'BWP',
		name_plural: 'Botswanan pulas',
	},
	{
		symbol: 'BYR',
		name: 'Belarusian Ruble',
		symbol_native: 'BYR',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'BYR',
		name_plural: 'Belarusian rubles',
	},
	{
		symbol: 'BZ$',
		name: 'Belize Dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'BZD',
		name_plural: 'Belize dollars',
	},
	{
		symbol: 'CDF',
		name: 'Congolese Franc',
		symbol_native: 'FrCD',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'CDF',
		name_plural: 'Congolese francs',
	},
	{
		symbol: 'CHF',
		name: 'Swiss Franc',
		symbol_native: 'CHF',
		decimal_digits: 2,
		rounding: 0.05,
		iso_code: 'CHF',
		name_plural: 'Swiss francs',
	},
	{
		symbol: 'CL$',
		name: 'Chilean Peso',
		symbol_native: '$',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'CLP',
		name_plural: 'Chilean pesos',
	},
	{
		symbol: 'CN\u00a5',
		name: 'Chinese Yuan',
		symbol_native: 'CN\u00a5',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'CNY',
		name_plural: 'Chinese yuan',
	},
	{
		symbol: 'CO$',
		name: 'Colombian Peso',
		symbol_native: '$',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'COP',
		name_plural: 'Colombian pesos',
	},
	{
		symbol: '\u20a1',
		name: 'Costa Rican Col\u00f3n',
		symbol_native: '\u20a1',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'CRC',
		name_plural: 'Costa Rican col\u00f3ns',
	},
	{
		symbol: 'CV$',
		name: 'Cape Verdean Escudo',
		symbol_native: 'CV$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'CVE',
		name_plural: 'Cape Verdean escudos',
	},
	{
		symbol: 'K\u010d',
		name: 'Czech Republic Koruna',
		symbol_native: 'K\u010d',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'CZK',
		name_plural: 'Czech Republic korunas',
	},
	{
		symbol: 'Fdj',
		name: 'Djiboutian Franc',
		symbol_native: 'Fdj',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'DJF',
		name_plural: 'Djiboutian francs',
	},
	{
		symbol: 'Dkr',
		name: 'Danish Krone',
		symbol_native: 'kr',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'DKK',
		name_plural: 'Danish kroner',
	},
	{
		symbol: 'RD$',
		name: 'Dominican Peso',
		symbol_native: 'RD$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'DOP',
		name_plural: 'Dominican pesos',
	},
	{
		symbol: 'DA',
		name: 'Algerian Dinar',
		symbol_native: '\u062f.\u062c.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'DZD',
		name_plural: 'Algerian dinars',
	},
	{
		symbol: 'Ekr',
		name: 'Estonian Kroon',
		symbol_native: 'kr',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'EEK',
		name_plural: 'Estonian kroons',
	},
	{
		symbol: 'EGP',
		name: 'Egyptian Pound',
		symbol_native: '\u062c.\u0645.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'EGP',
		name_plural: 'Egyptian pounds',
	},
	{
		symbol: 'Nfk',
		name: 'Eritrean Nakfa',
		symbol_native: 'Nfk',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'ERN',
		name_plural: 'Eritrean nakfas',
	},
	{
		symbol: 'Br',
		name: 'Ethiopian Birr',
		symbol_native: 'Br',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'ETB',
		name_plural: 'Ethiopian birrs',
	},
	{
		symbol: '\u00a3',
		name: 'Falkland Island Pound',
		symbol_native: '\u00a3',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'FKP',
		name_plural: 'Falkland Island Pounds',
	},
	{
		symbol: '\u00a3',
		name: 'British Pound Sterling',
		symbol_native: '\u00a3',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'GBP',
		name_plural: 'British pounds sterling',
	},
	{
		symbol: 'GEL',
		name: 'Georgian Lari',
		symbol_native: 'GEL',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'GEL',
		name_plural: 'Georgian laris',
	},
	{
		symbol: 'GH\u20b5',
		name: 'Ghanaian Cedi',
		symbol_native: 'GH\u20b5',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'GHS',
		name_plural: 'Ghanaian cedis',
	},
	{
		symbol: '\u00a3',
		name: 'Gibraltar Pound',
		symbol_native: '\u00a3',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'GHS1',
		name_plural: 'Gibraltar pound',
	},
	{
		symbol: 'FG',
		name: 'Guinean Franc',
		symbol_native: 'FG',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'GNF',
		name_plural: 'Guinean francs',
	},
	{
		symbol: 'GTQ',
		name: 'Guatemalan Quetzal',
		symbol_native: 'Q',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'GTQ',
		name_plural: 'Guatemalan quetzals',
	},
	{
		symbol: 'HK$',
		name: 'Hong Kong Dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'HKD',
		name_plural: 'Hong Kong dollars',
	},
	{
		symbol: 'HNL',
		name: 'Honduran Lempira',
		symbol_native: 'L',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'HNL',
		name_plural: 'Honduran lempiras',
	},
	{
		symbol: 'kn',
		name: 'Croatian Kuna',
		symbol_native: 'kn',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'HRK',
		name_plural: 'Croatian kunas',
	},
	{
		symbol: 'Ft',
		name: 'Hungarian Forint',
		symbol_native: 'Ft',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'HUF',
		name_plural: 'Hungarian forints',
	},
	{
		symbol: 'Rp',
		name: 'Indonesian Rupiah',
		symbol_native: 'Rp',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'IDR',
		name_plural: 'Indonesian rupiahs',
	},
	{
		symbol: '\u20aa',
		name: 'Israeli New Sheqel',
		symbol_native: '\u20aa',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'ILS',
		name_plural: 'Israeli new sheqels',
	},
	{
		symbol: 'Rs',
		name: 'Indian Rupee',
		symbol_native: '\u099f\u0995\u09be',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'INR',
		name_plural: 'Indian rupees',
	},
	{
		symbol: 'IQD',
		name: 'Iraqi Dinar',
		symbol_native: '\u062f.\u0639.',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'IQD',
		name_plural: 'Iraqi dinars',
	},
	{
		symbol: 'IRR',
		name: 'Iranian Rial',
		symbol_native: '\ufdfc',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'IRR',
		name_plural: 'Iranian rials',
	},
	{
		symbol: 'Ikr',
		name: 'Icelandic Kr\u00f3na',
		symbol_native: 'kr',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'ISK',
		name_plural: 'Icelandic kr\u00f3nur',
	},
	{
		symbol: 'J$',
		name: 'Jamaican Dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'JMD',
		name_plural: 'Jamaican dollars',
	},
	{
		symbol: 'JD',
		name: 'Jordanian Dinar',
		symbol_native: '\u062f.\u0623.',
		decimal_digits: 3,
		rounding: 0,
		iso_code: 'JOD',
		name_plural: 'Jordanian dinars',
	},
	{
		symbol: '\u00a5',
		name: 'Japanese Yen',
		symbol_native: '\uffe5',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'JPY',
		name_plural: 'Japanese yen',
	},
	{
		symbol: '\u0441',
		name: 'Kyrgyzstani som',
		symbol_native: '\u0441',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'KGS',
		name_plural: 'Kyrgyzstani som',
	},
	{
		symbol: 'Ksh',
		name: 'Kenyan shillings',
		symbol_native: 'Ksh',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'KES',
		name_plural: 'Kenyan shillings',
	},
	{
		symbol: 'KHR',
		name: 'Cambodian Riel',
		symbol_native: '\u17db',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'KHR',
		name_plural: 'Cambodian riels',
	},
	{
		symbol: 'CF',
		name: 'Comorian Franc',
		symbol_native: 'FC',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'KMF',
		name_plural: 'Comorian francs',
	},
	{
		symbol: '\u20a9',
		name: 'South Korean Won',
		symbol_native: '\u20a9',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'KRW',
		name_plural: 'South Korean won',
	},
	{
		symbol: 'KD',
		name: 'Kuwaiti Dinar',
		symbol_native: '\u062f.\u0643.',
		decimal_digits: 3,
		rounding: 0,
		iso_code: 'KWD',
		name_plural: 'Kuwaiti dinars',
	},
	{
		symbol: '$',
		name: 'Cayman Islands dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'KYD',
		name_plural: 'Cayman Islands dollarS',
	},
	{
		symbol: 'KZT',
		name: 'Kazakhstani Tenge',
		symbol_native: '\u0442\u04a3\u0433.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'KZT',
		name_plural: 'Kazakhstani tenges',
	},
	{
		symbol: '\u20ad',
		name: 'Lao kip',
		symbol_native: '\u20ad',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'LAK',
		name_plural: 'Lao kip',
	},
	{
		symbol: 'LB\u00a3',
		name: 'Lebanese Pound',
		symbol_native: '\u0644.\u0644.',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'LBP',
		name_plural: 'Lebanese pounds',
	},
	{
		symbol: 'SLRs',
		name: 'Sri Lankan Rupee',
		symbol_native: 'SL Re',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'LKR',
		name_plural: 'Sri Lankan rupees',
	},
	{
		symbol: '$',
		name: 'Liberian Dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'LRD',
		name_plural: 'Liberian Dollars',
	},
	{
		symbol: 'Lt',
		name: 'Lithuanian Litas',
		symbol_native: 'Lt',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'LTL',
		name_plural: 'Lithuanian litai',
	},
	{
		symbol: 'Ls',
		name: 'Latvian Lats',
		symbol_native: 'Ls',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'LVL',
		name_plural: 'Latvian lati',
	},
	{
		symbol: 'LD',
		name: 'Libyan Dinar',
		symbol_native: '\u062f.\u0644.',
		decimal_digits: 3,
		rounding: 0,
		iso_code: 'LYD',
		name_plural: 'Libyan dinars',
	},
	{
		symbol: 'MAD',
		name: 'Moroccan Dirham',
		symbol_native: '\u062f.\u0645.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'MAD',
		name_plural: 'Moroccan dirhams',
	},
	{
		symbol: 'MDL',
		name: 'Moldovan Leu',
		symbol_native: 'MDL',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'MDL',
		name_plural: 'Moldovan lei',
	},
	{
		symbol: 'MGA',
		name: 'Malagasy Ariary',
		symbol_native: 'MGA',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'MGA',
		name_plural: 'Malagasy Ariaries',
	},
	{
		symbol: 'MKD',
		name: 'Macedonian Denar',
		symbol_native: 'MKD',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'MKD',
		name_plural: 'Macedonian denari',
	},
	{
		symbol: 'MMK',
		name: 'Myanma Kyat',
		symbol_native: 'K',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'MMK',
		name_plural: 'Myanma kyats',
	},
	{
		symbol: 'MOP$',
		name: 'Macanese Pataca',
		symbol_native: 'MOP$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'MOP',
		name_plural: 'Macanese patacas',
	},
	{
		symbol: 'MURs',
		name: 'Mauritian Rupee',
		symbol_native: 'MURs',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'MUR',
		name_plural: 'Mauritian rupees',
	},
	{
		symbol: 'MK',
		name: 'Malawian Kwacha',
		symbol_native: 'MK',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'MWK',
		name_plural: 'Malawian Kwacha',
	},
	{
		symbol: 'MX$',
		name: 'Mexican Peso',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'MXN',
		name_plural: 'Mexican pesos',
	},
	{
		symbol: 'RM',
		name: 'Malaysian Ringgit',
		symbol_native: 'RM',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'MYR',
		name_plural: 'Malaysian ringgits',
	},
	{
		symbol: 'MTn',
		name: 'Mozambican Metical',
		symbol_native: 'MTn',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'MZN',
		name_plural: 'Mozambican meticals',
	},
	{
		symbol: 'N$',
		name: 'Namibian Dollar',
		symbol_native: 'N$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'NAD',
		name_plural: 'Namibian dollars',
	},
	{
		symbol: '\u20a6',
		name: 'Nigerian Naira',
		symbol_native: '\u20a6',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'NGN',
		name_plural: 'Nigerian nairas',
	},
	{
		symbol: 'C$',
		name: 'Nicaraguan C\u00f3rdoba',
		symbol_native: 'C$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'NIO',
		name_plural: 'Nicaraguan c\u00f3rdobas',
	},
	{
		symbol: 'Nkr',
		name: 'Norwegian Krone',
		symbol_native: 'kr',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'NOK',
		name_plural: 'Norwegian kroner',
	},
	{
		symbol: 'NPRs',
		name: 'Nepalese Rupee',
		symbol_native: '\u0928\u0947\u0930\u0942',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'NPR',
		name_plural: 'Nepalese rupees',
	},
	{
		symbol: 'NZ$',
		name: 'New Zealand Dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'NZD',
		name_plural: 'New Zealand dollars',
	},
	{
		symbol: 'OMR',
		name: 'Omani Rial',
		symbol_native: '\u0631.\u0639.',
		decimal_digits: 3,
		rounding: 0,
		iso_code: 'OMR',
		name_plural: 'Omani rials',
	},
	{
		symbol: 'B/.',
		name: 'Panamanian Balboa',
		symbol_native: 'B/.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'PAB',
		name_plural: 'Panamanian balboas',
	},
	{
		symbol: 'S/.',
		name: 'Peruvian Nuevo Sol',
		symbol_native: 'S/.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'PEN',
		name_plural: 'Peruvian nuevos soles',
	},
	{
		symbol: '\u20b1',
		name: 'Philippine Peso',
		symbol_native: '\u20b1',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'PHP',
		name_plural: 'Philippine pesos',
	},
	{
		symbol: 'PKRs',
		name: 'Pakistani Rupee',
		symbol_native: '\u20a8',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'PKR',
		name_plural: 'Pakistani rupees',
	},
	{
		symbol: 'z\u0142',
		name: 'Polish Zloty',
		symbol_native: 'z\u0142',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'PLN',
		name_plural: 'Polish zlotys',
	},
	{
		symbol: '\u20b2',
		name: 'Paraguayan Guarani',
		symbol_native: '\u20b2',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'PYG',
		name_plural: 'Paraguayan guaranis',
	},
	{
		symbol: 'QR',
		name: 'Qatari Rial',
		symbol_native: '\u0631.\u0642.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'QAR',
		name_plural: 'Qatari rials',
	},
	{
		symbol: 'RON',
		name: 'Romanian Leu',
		symbol_native: 'RON',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'RON',
		name_plural: 'Romanian lei',
	},
	{
		symbol: 'din.',
		name: 'Serbian Dinar',
		symbol_native: '\u0434\u0438\u043d.',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'RSD',
		name_plural: 'Serbian dinars',
	},
	{
		symbol: 'RUB',
		name: 'Russian Ruble',
		symbol_native: '\u0440\u0443\u0431.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'RUB',
		name_plural: 'Russian rubles',
	},
	{
		symbol: 'RWF',
		name: 'Rwandan Franc',
		symbol_native: 'FR',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'RWF',
		name_plural: 'Rwandan francs',
	},
	{
		symbol: 'SR',
		name: 'Saudi Riyal',
		symbol_native: '\u0631.\u0633.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'SAR',
		name_plural: 'Saudi riyals',
	},
	{
		symbol: '$',
		name: 'Solomon Islander Dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'SBD',
		name_plural: 'Solomon Islander Dollars',
	},
	{
		symbol: 'SDG',
		name: 'Sudanese Pound',
		symbol_native: 'SDG',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'SDG',
		name_plural: 'Sudanese pounds',
	},
	{
		symbol: 'Skr',
		name: 'Swedish Krona',
		symbol_native: 'kr',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'SEK',
		name_plural: 'Swedish kronor',
	},
	{
		symbol: 'S$',
		name: 'Singapore Dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'SGD',
		name_plural: 'Singapore dollars',
	},
	{
		symbol: 'Le',
		name: 'Sierra Leonean Leone',
		symbol_native: 'Le',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'SLL',
		name_plural: 'Sierra Leonean Leone',
	},
	{
		symbol: 'Ssh',
		name: 'Somali Shilling',
		symbol_native: 'Ssh',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'SOS',
		name_plural: 'Somali shillings',
	},
	{
		symbol: '\u00a3',
		name: 'South Sudanese pound',
		symbol_native: '\u00a3',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'SSP',
		name_plural: 'South Sudanese pound',
	},
	{
		symbol: 'Db',
		name: 'Sao Tomean Dobra',
		symbol_native: 'Db',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'STD',
		name_plural: 'Sao Tomean Dobra',
	},
	{
		symbol: 'SY\u00a3',
		name: 'Syrian Pound',
		symbol_native: '\u0644.\u0633.',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'SYP',
		name_plural: 'Syrian pounds',
	},
	{
		symbol: 'L',
		name: 'Swazi Lilangeni',
		symbol_native: 'L',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'SZL',
		name_plural: 'Swazi Lilangeni',
	},
	{
		symbol: '\u0e3f',
		name: 'Thai Baht',
		symbol_native: '\u0e3f',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'THB',
		name_plural: 'Thai baht',
	},
	{
		symbol: '\u0405\u041c',
		name: 'Tajikistani Somoni',
		symbol_native: '\u0405\u041c',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'THB1',
		name_plural: 'Tajikistani Somoni',
	},
	{
		symbol: 'DT',
		name: 'Tunisian Dinar',
		symbol_native: '\u062f.\u062a.',
		decimal_digits: 3,
		rounding: 0,
		iso_code: 'TND',
		name_plural: 'Tunisian dinars',
	},
	{
		symbol: 'T$',
		name: 'Tongan Pa\u02bbanga',
		symbol_native: 'T$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'TOP',
		name_plural: 'Tongan pa\u02bbanga',
	},
	{
		symbol: 'TL',
		name: 'Turkish Lira',
		symbol_native: 'TL',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'TRY',
		name_plural: 'Turkish Lira',
	},
	{
		symbol: 'TT$',
		name: 'Trinidad and Tobago Dollar',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'TTD',
		name_plural: 'Trinidad and Tobago dollars',
	},
	{
		symbol: 'NT$',
		name: 'New Taiwan Dollar',
		symbol_native: 'NT$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'TWD',
		name_plural: 'New Taiwan dollars',
	},
	{
		symbol: 'TSh',
		name: 'Tanzanian Shilling',
		symbol_native: 'TSh',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'TZS',
		name_plural: 'Tanzanian shillings',
	},
	{
		symbol: '\u20b4',
		name: 'Ukrainian Hryvnia',
		symbol_native: '\u20b4',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'UAH',
		name_plural: 'Ukrainian hryvnias',
	},
	{
		symbol: 'USh',
		name: 'Ugandan Shilling',
		symbol_native: 'USh',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'UGX',
		name_plural: 'Ugandan shillings',
	},
	{
		symbol: '$U',
		name: 'Uruguayan Peso',
		symbol_native: '$',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'UYU',
		name_plural: 'Uruguayan pesos',
	},
	{
		symbol: 'UZS',
		name: 'Uzbekistan Som',
		symbol_native: 'UZS',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'UZS',
		name_plural: 'Uzbekistan som',
	},
	{
		symbol: 'Bs.F.',
		name: 'Venezuelan Bol\u00edvar',
		symbol_native: 'Bs.F.',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'VEF',
		name_plural: 'Venezuelan bol\u00edvars',
	},
	{
		symbol: '\u20ab',
		name: 'Vietnamese Dong',
		symbol_native: '\u20ab',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'VND',
		name_plural: 'Vietnamese dong',
	},
	{
		symbol: 'Vt',
		name: 'Ni-Vanuatu Vatu',
		symbol_native: 'Vt',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'VUV',
		name_plural: 'Ni-Vanuatu Vatu',
	},
	{
		symbol: 'FCFA',
		name: 'CFA Franc BEAC',
		symbol_native: 'FCFA',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'XAF',
		name_plural: 'CFA francs BEAC',
	},
	{
		symbol: '$',
		name: 'East Caribbean Dollar',
		symbol_native: '$',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'XCD',
		name_plural: 'East Caribbean Dollars',
	},
	{
		symbol: 'CFA',
		name: 'CFA Franc BCEAO',
		symbol_native: 'CFA',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'XOF',
		name_plural: 'CFA francs BCEAO',
	},
	{
		symbol: 'Fr',
		name: 'CFP franc',
		symbol_native: 'Fr',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'XPF',
		name_plural: 'CFP franc',
	},
	{
		symbol: 'YR',
		name: 'Yemeni Rial',
		symbol_native: '\u0631.\u064a.',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'YER',
		name_plural: 'Yemeni rials',
	},
	{
		symbol: 'R',
		name: 'South African Rand',
		symbol_native: 'R',
		decimal_digits: 2,
		rounding: 0,
		iso_code: 'ZAR',
		name_plural: 'South African rand',
	},
	{
		symbol: 'ZK',
		name: 'Zambian Kwacha',
		symbol_native: 'ZK',
		decimal_digits: 0,
		rounding: 0,
		iso_code: 'ZMK',
		name_plural: 'Zambian kwachas',
	},
];
